export default "__VITE_PUBLIC_ASSET__34d7a2c6__"